// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-483853b4]:export {\n  menuBg: #b58643;\n  menuText: #e0e0e0;\n  menuActiveText: #ffe164;\n  menuActiveBg: #906a35;\n}\n\n/* Mixins */\n.scheme-discount-form.form-block[data-v-483853b4] {\n  width: 95%;\n}\n.scheme-discount-form[data-v-483853b4] .el-table thead th,\n.scheme-discount-form[data-v-483853b4] .el-table thead.is-group th {\n  background-color: #b58643;\n  color: #fff;\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
